import PropTypes from "prop-types";
import React from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { STORE_LOV } from "../../../apollo/queries";
import useEditWarehouse from "../../../controllers/useEditWarehouse";
import Dropdown from "../../../feature-module/components/Dropdown";
import InputField from "../../../feature-module/components/InputField";
import ErrorMessage from "../../../feature-module/components/errorMessage";

const EditWarehouse = (props, { refetch }) => {
  const { values, functions } = useEditWarehouse(props, refetch);

  return (
    <div className="modal fade" id="edit-units">
      <div
        className="modal-dialog modal-dialog-centered custom-modal-two"
        style={{ maxWidth: "50%" }}
      >
        <div className="modal-content">
          <div className="page-wrapper-new p-0">
            <div className="content p-0">
              <div className="modal-header border-0 custom-modal-header">
                <div className="page-title">
                  <h4>Edit Warehouse</h4>
                </div>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={functions.onCancel}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body custom-modal-body">
                <form>
                  <div className="modal-title-head">
                    <h6>
                      <span>
                        <i data-feather="info" className="feather-info me-2" />
                      </span>
                      Warehouse Info
                    </h6>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="mb-3 war-add">
                        <Controller
                          name="store_id"
                          control={values.control}
                          rules={{ required: "Store is required" }}
                          render={({ field }) => (
                            <Dropdown
                              query={STORE_LOV}
                              dataKey="listStore"
                              variables={{ input: null }}
                              label="Store"
                              required
                              placeholder="Select Store"
                              field={field}
                              onChange={(value) => field.onChange(value?.value)}
                              disabled
                            />
                          )}
                        />
                        <ErrorMessage
                          error={values.errors?.store_id?.message}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <Controller
                          name="name"
                          control={values.control}
                          rules={{ required: "Name is required" }}
                          render={({ field }) => (
                            <InputField
                              label="Name"
                              type="text"
                              placeholder="Enter Name"
                              required
                              {...field}
                            />
                          )}
                        />
                        <ErrorMessage error={values.errors.name?.message} />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-blocks">
                        <Controller
                          name="phone"
                          control={values.control}
                          rules={{ required: "Phone is required" }}
                          render={({ field }) => (
                            <InputField
                              label="Phone"
                              type="number"
                              placeholder="Enter Phone"
                              required
                              {...field}
                            />
                          )}
                        />
                        <ErrorMessage error={values.errors.phone?.message} />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="mb-3">
                        <Controller
                          name="address.address"
                          control={values.control}
                          rules={{ required: "Address is required" }}
                          render={({ field }) => (
                            <InputField
                              label="Address"
                              type="text"
                              placeholder="Enter Address"
                              required
                              {...field}
                            />
                          )}
                        />
                        <ErrorMessage
                          error={values.errors?.address?.address?.message}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-blocks">
                        <label className="form-label">
                          Country <span> *</span>
                        </label>
                        <Controller
                          name="address.country"
                          control={values.control}
                          rules={{ required: "Country is required" }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              classNamePrefix="react-select"
                              className="mb-2"
                              options={values.countries}
                              placeholder="Select Country"
                              value={field?.value}
                              onChange={(selectedOption) => {
                                field.onChange(selectedOption);
                                functions.resetField("address.state");
                                functions.resetField("address.city");
                              }}
                            />
                          )}
                        />
                        <ErrorMessage
                          error={values.errors?.address?.country?.message}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label">
                          State <span> *</span>
                        </label>
                        <Controller
                          name="address.state"
                          control={values.control}
                          rules={{ required: "State is required" }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              classNamePrefix="react-select"
                              className="mb-2"
                              options={values.states}
                              placeholder="Select State"
                              value={field?.value}
                              onChange={(selectedOption) => {
                                field.onChange(selectedOption);
                                functions.resetField("address.city");
                              }}
                            />
                          )}
                        />
                        <ErrorMessage
                          error={values.errors?.address?.state?.message}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3 mb-0">
                        <label className="form-label">
                          City<span> *</span>
                        </label>
                        <Controller
                          name="address.city"
                          control={values.control}
                          rules={{ required: "City is required" }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              classNamePrefix="react-select"
                              className="mb-2"
                              options={values.cities}
                              placeholder="Select City"
                              value={field?.value}
                              onChange={(selectedOption) =>
                                field.onChange(selectedOption)
                              }
                            />
                          )}
                        />
                        <ErrorMessage
                          error={values.errors?.address?.city?.message}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3 mb-0">
                        <Controller
                          name="address.zip"
                          control={values.control}
                          rules={{ required: "Zip is required" }}
                          render={({ field }) => (
                            <InputField
                              label="Zip"
                              type="text"
                              placeholder="Enter Zip"
                              required
                              {...field}
                            />
                          )}
                        />
                        <ErrorMessage
                          error={values.errors?.address?.zip?.message}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer-btn">
                    <button
                      type="button"
                      className="btn btn-cancel me-2"
                      data-bs-dismiss="modal"
                      onClick={functions.onCancel}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      disabled={values.loading}
                      className="btn btn-submit"
                      onClick={functions.onSubmit}
                    >
                      {values.loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Saving...
                        </>
                      ) : (
                        "Save Changes"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

EditWarehouse.propTypes = {
  rowData: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    store_id: PropTypes.bool.isRequired,
    address: PropTypes.object.isRequired,
  }).isRequired,
  refetch: PropTypes.func.isRequired,
};

export default EditWarehouse;
